import { useQueries } from '@tanstack/react-query';
import { LearnableDetailsApi } from 'src/api';
import { LearnablePronunciationData } from 'src/api/userDictionary/types';

/**
 * Every native speaker clip across the session's words. Shares the query key
 * the session screen uses, so nothing is fetched twice.
 */
export const useSessionSpeakerClips = (learnables: LearnablePronunciationData[]): string[] => {
  const speakerMedia = useQueries({
    queries: learnables.map(({ learnableIdKey }) => ({
      queryKey: ['learnableDetails', learnableIdKey],
      queryFn: () => LearnableDetailsApi.getLearnableDetails(learnableIdKey),
    })),
  });

  return speakerMedia.flatMap(query => query.data?.videoUrls ?? []);
};
